import axios from "axios";
import { serverURL,headeroption,headeroptionupload } from "../http-common";

class LocationService {
  getallLocation(data) {
    return axios.get(serverURL + "/location-api?req=smarttableLocation", {
      params: data,
      headers: headeroption,
    })
  }
  getLocation(location_id) {
    return axios.get(serverURL + "/location-api?req=getLocation", {
      params: { location_id: location_id }, headers: headeroption,
    });
  }
  createLocation(data) {
    return axios.post(serverURL + "/location-api?req=createLocation", data, {
      headers: headeroption,
    });
  }
  updateLocation(data) {
    return axios.put(serverURL + "/location-api?req=updateLocation", data, {
      headers: headeroption,
    });
  }
  deleteLocation(location_id) {
    return axios.delete(serverURL + "/location-api?req=deleteLocation", { params: { location_id: location_id }, headers: headeroption, });
  }
  deleteAll() {
    return axios.delete(serverURL + "/location-api?req=deleteLocation");
  }
  findByTitle(location_name) {
    return axios.get(serverURL + "/location/location-api?name=" + location_name);
  }
  upload(location_id, data) {
    return axios.post(serverURL + "/uploads-api/singlefile?location_id=" + location_id, data, { headers: headeroptionupload });
  }
  uploads(location_id, data) {
    return axios.post(serverURL + "/uploads-api/uploadmultifile?location_id=" + location_id, data, { headers: headeroptionupload });
  }
}
export default new LocationService();
